<section class="approvals">
  <header class="approvals__head">
    <h1 class="approvals__title">Approval Dashboard</h1>
    <p class="approvals__desc">
      Reporting periods that have been reviewed, newest first. Each row tracks one
      department through its three gates — Reviewed, Approved and Shared — with who
      acted and when.
    </p>
  </header>

  <div class="approvals__toolbar">
    <button
      pButton
      type="button"
      label="Refresh"
      icon="pi pi-refresh"
      [disabled]="loading"
      (click)="load()">
    </button>
  </div>

  @if (error) {
    <p class="approvals__error" role="alert">{{ error }}</p>
  }

  <div class="approvals__tablewrap">
    <div class="approvals__caption">
      <span class="approvals__caption-title">Reviewed process log</span>
      <span class="approvals__caption-meta">{{ rows.length }} rows</span>
    </div>

    <p-table
      [value]="rows"
      [loading]="loading"
      [scrollable]="true"
      scrollHeight="520px"
      [paginator]="rows.length > 10"
      [rows]="10"
      [rowsPerPageOptions]="[10, 20, 50]"
      paginatorDropdownAppendTo="body"
      styleClass="p-datatable-sm p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Process</th>
          <th>Department</th>
          <th>Reporting Period</th>
          <th>Reviewed</th>
          <th>Approved</th>
          <th>Shared</th>
          <th>Run Date</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.processname }}</td>
          <td>
            <span class="dept dept--{{ departmentClass(row) }}">{{ row.department }}</span>
          </td>
          <td class="period">{{ formatPeriod(row.reportingperiod) }}</td>
          <td>
            <span class="gate">
              <span class="gate__pill" [class.gate__pill--done]="isDone(row, 'reviewed')">
                {{ gateLabel(row, 'reviewed') }}
              </span>
              @if (gateMeta(row, 'reviewed')) {
                <span class="gate__meta">{{ gateMeta(row, 'reviewed') }}</span>
              }
            </span>
          </td>
          <td>
            <span class="gate">
              <span class="gate__pill" [class.gate__pill--done]="isDone(row, 'approved')">
                {{ gateLabel(row, 'approved') }}
              </span>
              @if (gateMeta(row, 'approved')) {
                <span class="gate__meta">{{ gateMeta(row, 'approved') }}</span>
              }
            </span>
          </td>
          <td>
            <span class="gate">
              <span class="gate__pill" [class.gate__pill--done]="isDone(row, 'shared')">
                {{ gateLabel(row, 'shared') }}
              </span>
              @if (gateMeta(row, 'shared')) {
                <span class="gate__meta">{{ gateMeta(row, 'shared') }}</span>
              }
            </span>
          </td>
          <td class="period">{{ formatDateTime(row.rundate) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="approvals__empty">
            No reviewed reporting periods yet. A period appears here once its
            department row is marked reviewed.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
